import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { getApi } from "../../utils/api";
import {
  API_DOWNLOAD_SALARY,
  API_GET_REIMBURSEMENT_TYPES,
  API_REIMBURSEMENT_LIST,
} from "../../config/Endpoints";
import { Link } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import Pagination from "../../components/Pagination";
import ReimbursementWithdrawRequest from "./ReimbursementWithdrawRequest";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import Select from "react-select";
import { generateMonths, getYearsUpToCurrent } from "../../utils/helpers";
import { displayFormatDate } from "../../utils/helpers";
import SortableTable from "../../components/SortableTable";

// Data table
// import DataTable from "react-data-table-component";

const ReimbursementRequestList = ({ title, description }) => {
  const [reimbursementList, setReimbursementList] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isReimbursementRequest, setIsReimbursementRequest] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "",
  });
  const [reimbursementId, setReimbursementId] = useState("");
  const [selectedReimbursementRequest, setSelectedReimbursementRequest] =
    useState({});
  const [reimbursementTypes, setReimbursementTypes] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalReimbursement, setTotalReimbursement] = useState(0);
  const [months, setMonths] = useState(generateMonths());
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const years = getYearsUpToCurrent(2020).map((year) => ({
    value: year,
    label: year,
  }));

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const columns = [
    {
      key: "reimbursementType",
      label: "Reimbursement Type",
    },
    {
      key: "requestDate",
      label: "Requested Date",
    },
    {
      key: "date",
      label: "Invoice Date",
      render: (row) => displayFormatDate(row.date, true),
      compare: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      key: "invoiceNo",
      label: "Invoice No.",
    },
    {
      key: "reimbursementAmount",
      label: "Amount",
      render: (row) => row.reimbursementAmount.toLocaleString("en-IN"),
      compare: (a, b) => a.reimbursementAmount - b.reimbursementAmount,
    },
    {
      key: "trackingStatus",
      label: "Status",
    },
    {
      key: "action",
      label: "Action",
      sortable: false,
      render: (row) =>
        row.trackingStatus === "Discrepancy" ||
        row.trackingStatus === "Pending-Admin" ? (
          <a
            data-bs-toggle="modal"
            data-bs-target="#staticBackdropAssetwithdraw"
            onClick={() => {
              setReimbursementId(row.reimbursementId);
              setSelectedReimbursementRequest(row);
            }}
          >
            Withdraw
          </a>
        ) : (
          <p className="ms-2">-</p>
        ),
    },
  ];

  useEffect(() => {
    fetchList();
  }, [currentPage, limit]);

  useEffect(() => {
    getApi(API_GET_REIMBURSEMENT_TYPES, accessToken)
      .then((res) => {
        if (res.status === 200) {
          const types = res.data.data.map((item) => ({
            value: item.reimbursemnetType,
            label: item.reimbursemnetType,
          }));
          setReimbursementTypes(types);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let filteredMonths = generateMonths();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    if (selectedYear === currentYear) {
      filteredMonths = filteredMonths.filter(
        (month) => parseInt(month.value) <= currentMonth
      );
    }

    setMonths(filteredMonths);
  }, [selectedYear]);

  useEffect(() => {
    if (!selectedYear && !selectedMonth && !selectedType) {
      fetchList();
    }
  }, [selectedYear, selectedMonth, selectedType]);

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setCurrentPage(1);
  };

  const fetchList = () => {
    setIsLoading(true);

    let query = `?page=${currentPage}&pageSize=${limit}&`;

    if (selectedYear) query += `year=${selectedYear.value}&`;
    if (selectedMonth) query += `month=${selectedMonth.value}&`;
    if (selectedType)
      query += `reimbursementType=${encodeURIComponent(selectedType.value)}&`;

    query = query.slice(0, -1);

    getApi(API_REIMBURSEMENT_LIST + query, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setReimbursementList(res.data.data);
          setFilteredItems(res.data.data);
          setTotalReimbursement(res.data.totalRequest);
          setTotalPages(res.data.totalPages);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    const filtered = reimbursementList.filter((item) =>
      item.reimbursementType.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredItems(filtered);
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
    const sortedData = [...filteredItems].sort((a, b) => {
      if (key === "requestDate" || key === "date") {
        const dateA = new Date(a[key]);
        const dateB = new Date(b[key]);
        if (dateA < dateB) {
          return direction === "ascending" ? -1 : 1;
        }
        if (dateA > dateB) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      } else {
        if (a[key] < b[key]) {
          return direction === "ascending" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      }
    });

    setFilteredItems(sortedData);
  };

  return (
    <div className="wrapper-body">
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Reimbursement : <span>{totalReimbursement}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="filters">
        {/* <form action="index.html" id="form_filters" className="d-f"> */}
        {/* Search By Company */}
        <div className="filter">
          <label className="label"> Reimbursement Type</label>

          <div className="search">
            <Select
              options={reimbursementTypes}
              value={selectedType}
              onChange={setSelectedType}
              placeholder="Select Reimbursement Type"
              className="width-100 pr"
              isClearable
            />
          </div>
        </div>

        <div className="filter">
          {" "}
          <label className="label"> Year</label>
          <div className="search">
            <Select
              options={years}
              value={selectedYear}
              onChange={(year) => {
                setSelectedYear(year || null);
                setSelectedMonth(null);
              }}
              placeholder="Select Year"
              className="width-100 pr"
              isClearable
            />
          </div>
        </div>

        {/* Month Filter */}
        {selectedYear && (
          <div className="filter">
            <label className="label"> Month</label>
            <div className="search">
              <Select
                options={months}
                value={selectedMonth}
                onChange={(month) => setSelectedMonth(month || null)}
                placeholder="Select Month"
                className="width-100 pr"
                isClearable
              />
            </div>
          </div>
        )}

        {/* <button type="submit" form="form_filters">
          Search
        </button> */}
        {/* </form> */}

        {/* Actions */}
        <div className="actions">
          <button className="theme-button" onClick={fetchList}>
            Filter
          </button>
          <Link
            to="/dashboard/createReimbursementRequest"
            className="export theme-button"
          >
            Reimbursement Request
          </Link>
          {/* {isReimbursementTimeSlot() ? (
            <Link
              to="/dashboard/createReimbursementRequest"
              className="export theme-button"
            >
              Reimbursement Request
            </Link>
          ) : (
            <button className="theme-button" onClick={handleReimbursementClick}>
              Reimbursement Request
            </button>
          )} */}
        </div>
      </div>

      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      {/* Data Table */}
      {!isLoading && filteredItems?.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={filteredItems}
            currentPage={currentPage}
            limit={limit}
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25  p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      )}

      <div
        className="modal fade"
        id="staticBackdropAssetwithdraw"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <ReimbursementWithdrawRequest
              reimbursementId={reimbursementId}
              selectedReimbursementRequest={selectedReimbursementRequest}
              fetchList={fetchList}
            />
          </div>
        </div>
      </div>
      {!isLoading && filteredItems?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          <h4>No Record Available</h4>
        </div>
      )}
      {/* <DataTable columns={columns} data={data} pagination /> */}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ReimbursementRequestList;
